import { FilterKey } from '@app/hooks/use-data-table-query-state';

/**
 * Facet filters for the sold-goods uncategorised (Uncertain / Other) tabs. The
 * shared Excluded items toolbar writes the selected values to the URL under the
 * `column` keys; each tab maps them to the endpoint's `apiKey` query params when
 * fetching its list.
 *
 * Sold goods carry no Supplier or Tags facet; Customer is the sold-side
 * sibling of the purchased Supplier facet.
 */
export const uncategorisedFilters = [
  { column: 'site', apiKey: 'sites' },
  { column: 'period', apiKey: 'time_periods' },
  { column: 'customer', apiKey: 'customers' },
  { column: 'activitiesImport', apiKey: 'activity_imports' },
] as const;

/** URL filter keys read from query state, alongside `search`. */
export const uncategorisedFilterColumns = uncategorisedFilters.map(
  (filter) => filter.column
) as FilterKey[];
